import CommonLoadingAnimation from '@/shared/components/CommonLoadingAnimation';
import { useLoadingOverlayStore } from '@/shared/store/loadingOverlayStore';
import { createPortal } from 'react-dom';

export default function GlobalLoadingOverlay() {
  const isLoading = useLoadingOverlayStore((state) => state.isLoading);

  return createPortal(isLoading && <CommonLoadingAnimation fullPage={true} size='10rem' text='Loading...' />, document.body);
}
